import { componentProvider } from 'js-component-framework';
import getFormattedClassnames from 'utils/getFormattedClassnames';
import HeaderSearch from './header-search';

const searchClassnames = sciencenewsClassnames['header-search'];
const searchSelectors = getFormattedClassnames(searchClassnames);

const headerSearchConfig = {
  name: 'header-search',
  component: HeaderSearch,
  querySelector: {
    target: searchSelectors.wrapper,
    controller: searchSelectors.toggle,
    openText: searchSelectors.open,
    closeText: searchSelectors.close,
    input: 'input',
  },
};

componentProvider(headerSearchConfig);
